<script lang="ts">
	import ServicePage from "../components/ServicePage.svelte";
	import type { ServiceSparePartsProps } from "./ServiceSparePartsProps.js";
	import spareParts1 from "../assets/images/nahradni-dily-1.jpg?webp&w=1920&imagetools";
	import spareParts2 from "../assets/images/nahradni-dily-2.jpg?webp&w=1920&imagetools";
	import spareParts3 from "../assets/images/nahradni-dily-3.jpg?webp&w=1920&imagetools";
	import spareParts4 from "../assets/images/nahradni-dily-4.jpg?webp&w=1920&imagetools";

	type $$Props = ServiceSparePartsProps;

	const { references, blogPosts } = $$restProps as $$Props;

	const images = [spareParts1, spareParts2, spareParts3, spareParts4];

	const heading = "Náhradní díly nebo servis? \n Není problém";
	const title =
		"Naše služba Servis a náhradní díly poskytuje rychlou a spolehlivou podporu pro udržení vašich skladovacích systémů v optimálním stavu.";
	const perex =
		"Tým zkušených techniků společnosti BITO je připraven provádět pravidelnou údržbu, opravy \n a případné výměny poškozených dílů, aby byl zajištěn plynulý chod vašeho skladu.";
	const perex2 =
		"Nabízíme širokou škálu originálních náhradních dílů, které jsou okamžitě dostupné, a rychlé dodávky \n zajišťují minimální prostoje. Naše servisní služby vám pomohou prodloužit životnost vašich skladovacích \n systémů a minimalizovat neplánované výpadky provozu.";
</script>

<ServicePage {heading} {title} {perex} {perex2} {images} {references} {blogPosts} />
